import { FC, memo } from 'react';
import { SkeletonWrapper } from './skeleton.styled';
import { Skeleton } from '../../components-v4';

export const RequestSkeleton: FC = memo(() => {
  return (
    <SkeletonWrapper>
      <Skeleton
        width={'120px'}
        height={'24px'}
        style={{ marginBottom: '16px' }}
      />
      <Skeleton
        width={'80px'}
        height={'20px'}
        style={{ marginBottom: '8px' }}
      />
      <Skeleton
        width={'100%'}
        height={'380px'}
        style={{ marginBottom: '16px' }}
      />
      <Skeleton
        width={'120px'}
        height={'24px'}
        style={{ marginBottom: '16px' }}
      />
      <Skeleton width={'180px'} height={'48px'} />
    </SkeletonWrapper>
  );
});
